import siteReducers from 'yoda-site-components/lib/reducers';
import AddToCartInterstitialReducer from 'yoda-checkout-components/lib/reducers/AddToCartInterstitialReducer';
import CarePlanWarrantyReducer from 'yoda-checkout-components/lib/reducers/CarePlanWarrantyReducer';
import ShowGlobalLoaderReducer from 'yoda-checkout-components/lib/reducers/ShowGlobalLoaderReducer';
import MessageContentReducer from 'yoda-checkout-components/lib/reducers/MessageContentReducer';
import { DigitalAnalyticsDataReducer } from 'yoda-checkout-components/lib/reducers/AnalyticsReducer';
import CustomOptionsReducer from 'yoda-site-components/lib/reducers/CustomOptionsReducer';
import InventoryReducer from 'yoda-site-components/lib/reducers/InventoryReducer';
import ProductDetailsReducer from 'yoda-site-components/lib/reducers/ProductDetailsReducer';
import ProductOptionsReducer from 'yoda-site-components/lib/reducers/ProductOptionsReducer';
import ProductPricingReducer from 'yoda-site-components/lib/reducers/ProductPricingReducer';
import PdpNameSpaceReducerCreator from 'yoda-site-components/lib/reducers/PdpNameSpaceReducerCreator';
import CouponDetailsReducer from 'yoda-site-components/lib/reducers/CouponDetailsReducer';
import QuantityReducer from 'yoda-site-components/lib/reducers/QuantityReducer';
import MiniPDPReducer from 'yoda-site-components/lib/reducers/MiniPDPReducer';
import MyAlertsReducer from 'yoda-site-components/lib/reducers/MyAlertsReducer';
import LocationServiceReducer from 'yoda-site-components/lib/reducers/LocationServiceReducer';
import BOPISMessageReducer from 'yoda-site-components/lib/reducers/BOPISMessageReducer';
import LoadingReducer from 'yoda-site-components/lib/reducers/LoadingReducer';
import MTLSavedLists from 'yoda-site-components/lib/reducers/SavedListToolTip';
import MessagesReducer from 'yoda-site-components/lib/reducers/MessagesReducer';

import InlineImageLoaderReducer from 'yoda-site-components/lib/reducers/InlineImageLoaderReducer';
import ColorSwatchesReducer from 'yoda-site-components/lib/reducers/ColorSwatchesReducer';
import ProtectionPlanReducer from 'yoda-site-components/lib/reducers/ProtectionPlanReducer';
import SdpuStoreInfoReducer from 'yoda-site-components/lib/reducers/SdpuStoreInfoReducer';
import BVReviewsReducer from 'yoda-site-components/lib/reducers/BVReviewsReducer';
import MyAlertsModalReducer from 'yoda-site-components/lib/reducers/MyAlertsModalReducer';
import IrisReducer from 'yoda-site-components/lib/reducers/IrisReducer';
import ShopTheLookReducer from 'yoda-site-components/lib/reducers/ShopTheLookReducer';
import WebvitalsReducer from 'yoda-site-components/lib/reducers/WebvitalsReducer';
import SYFQuickScreenReducer from 'yoda-account-components/lib/reducers/SYFQuickScreenReducer';
import ShippingProtectionModalReducer from 'yoda-checkout-components/lib/reducers/ShippingProtectionModalReducer';
import IrisS1PromotionalBannerReducer from './IrisS1PromotionalBannerReducer';
import ProductPricingFallBackReducer from './ProductPricingFallBackReducer';
import ProductSpecificationsReducer from './ProductSpecificationsReducer';
import AddToCartReducer from './AddToCartReducer';
import ProductContentReducer from './ProductContentReducer';
import DeliveryOptionReducer from './DeliveryOptionReducer';
import DeliveryOptionsNameReducer from './DeliveryOptionsNameReducer';
import DeliveryZipcodeReducer from './DeliveryZipcodeReducer';
import PDPBreadcrumbsReducer from './PDPBreadcrumbsReducer';
import QueryParamsReducer from './QueryParamsReducer';
import AnalyticsReducer from './AnalyticsReducer';
import BundlePricingReducer from './BundlePricingReducer';
import FromGalleryReducer from './FromGalleryReducer';
import VisitStoreToPurchaseReducer from './VisitStoreToPurchaseReducer';
import UrgencyMessagingReducer from './UrgencyMessagingReducer';
import ProductCollectionPricingReducer from './ProductCollectionPricingReducer';
import SignInSliderReducer from './SignInSliderReducer';
import BazaarVoiceReducer from './BazaarVoiceReducer';
import BundleProductOptionsOnLoadReducer from './BundleProductOptionsOnLoadReducer';
import VirtualTryOnReducer from './VirtualTryOnReducer';
import CreditCardBannerReducer from './CreditCardBannerReducer';
import CMCreditCardBannerReducer from './CMCreditCardBannerReducer';
import bundleItemOfferingReducer from './BundleItemOfferingReducer';
// Whenever you add any property to the rootReducer,
// add the same to the pdpStore object in PDP.test.jsx file and assign the default value.

const rootReducer = {
    ...siteReducers,
    /**
     * To get a product related specifications
     * src/components/ProductSpecifications/ProductSpecifications.jsx
     */
    productSpecifications: ProductSpecificationsReducer,
    irisS1PromotionalBannerReducerData: IrisS1PromotionalBannerReducer,
    /**
     * To get add to cart status success/failue
     * src/components/AddToCart/AddToCart.jsx
     * src/components/Bundle/BundleAddToCart/BundleAddToCart.jsx
     * src/components/DeliveryOption/DeliveryOption.jsx
     * src/sagas/AddToCartSaga.js
     * src/sagas/UpdateCartSaga.js
     */
    addToCart: AddToCartReducer,
    /**
     * To get a product General information and shipping & return details
     * src/components/GeneralInformation/GeneralInformation.jsx
     * src/components/ShippingAndReturns/ShippingAndReturns.jsx
     */
    productContent: ProductContentReducer,
    /**
     * To get product delivery details
     * src/components/DeliveryOption/DeliveryOption.jsx
     */
    deliveryOption: DeliveryOptionReducer,
    /**
     * To get a product custom options details
     * src/components/AddToCart/AddToCart.jsx
     * src/components/AddToCart/withAddToCartHOC.jsx
     * src/components/DeliveryOption/DeliveryOption.jsx
     * src/components/StickyHeader/StickyHeader.jsx
     * yoda-site-components/src/components/CustomOptions/CustomOptions.jsx
     * yoda-site-components/src/components/ProductPricing/ProductPricing.jsx
     */
    customOptions: CustomOptionsReducer,
    /**
     * To get product delivery address zipcode
     * yoda-checkout-components/src/sagas/SilverBundleSaga.js
     * src/components/AddToCart/AddToCart.jsx
     * src/components/DeliveryDate/DeliveryDate.jsx
     * src/components/StickyHeader/StickyHeader.jsx
     * src/components/Bundle/BundleAddToCart/BundleAddToCart.jsx
     * src/components/Bundle/BundleEcoRebates/BundleEcoRebates.jsx
     * src/components/DeliveryOption/DeliveryOption.jsx
     * src/components/GeneralInformation/GeneralInformation.jsx
     * yoda-site-components/src/components/EcoRebates/EcoRebates.jsx
     * yoda-site-components/src/components/EcoRebates/EcoRebatesModal.jsx
     */
    deliveryZipcode: DeliveryZipcodeReducer,
    /**
     * To get breadcrumb details
     * src/components/PDPBreadcrumbs/PDPBreadcrumbs.jsx
     */
    breadcrumbsData: PDPBreadcrumbsReducer,
    /**
     * To get query paramas details
     * src/selectors/AddToCartSelector.js
     * yoda-site-components/src/selectors/ProductOptionsSelector.js
     * yoda-site-components/src/selectors/QuerySelector.js
     */
    queryParams: QueryParamsReducer,
    /**
     * To get a product add to cart details
     * yoda-checkout-components/src/components/AddToCartInterstitial/AddToCartInterstitial.jsx
     * yoda-checkout-components/src/sagas/SilverBundleSaga.js
     * yoda-microsite-listing/src/containers/Pages/Lists/ListLandingPageConnect.jsx
     * yoda-microsite-listing/src/containers/Pages/TrendingList/TrendingListConnect.jsx
     * src/components/AddToCart/AddToCart.jsx
     * src/components/ProductCollection/ProductCollection.jsx
     */
    addToCartInterstitialDetails: AddToCartInterstitialReducer,
    /**
     * To get a care plan warranty learn more content
     * yoda-checkout-components/src/components/AddToCartInterstitial/AddToCartInterstitial.jsx
     * yoda-checkout-components/src/sagas/SilverBundleSaga.js
     * yoda-microsite-listing/src/containers/Pages/Lists/ListLandingPageConnect.jsx
     * yoda-microsite-listing/src/containers/Pages/TrendingList/TrendingListConnect.jsx
     * src/components/AddToCart/AddToCart.jsx
     * src/components/ProductCollection/ProductCollection.jsx
     */
    carePlanWarrantyDetails: CarePlanWarrantyReducer,
    /**
     * To get product pricing fall bact details
     * yoda-site-components/src/selectors/fromState/index.js
     * yoda-site-components/src/selectors/ProductPricingSelector.js
     */
    ProductPricingFallBack: ProductPricingFallBackReducer,
    /**
     * To collect analystics details
     * src/components/ProductImage/ProductImage.jsx
     * src/containers/Pages/PDP/Bundle/Bundle.jsx
     * src/containers/Pages/PDP/Common/Common.jsx
     * src/containers/Pages/PDP/PDP.jsx
     */
    Analytics: AnalyticsReducer,
    /**
     * To display loader to the page
     * yoda-checkout-components/src/components/AddToCartInterstitial/AddToCartInterstitial.jsx
     * yoda-microsite-checkout/src/containers/Pages/NewCheckoutPage/NewCheckoutPage.jsx
     * yoda-site-components/src/components/Layout/Layout.jsx
     */
    showGlobalLoader: ShowGlobalLoaderReducer,
    messageContentData: MessageContentReducer,
    /**
     * To get bundle pricing details
     * src/components/Bundle/BundleAddToCart/BundleAddToCart.jsx
     * src/selectors/Bundle/BundleProductPricingSelector.js
     * yoda-site-components/src/analytics/PDPAnalytics.js
     */
    bundlePrice: BundlePricingReducer,
    /**
     * To know whther user navigating from Gallery or not.
     * src/components/PDPBreadcrumbs/PDPBreadcrumbs.jsx
     * src/components/ProductInfo/ProductInfoDesktop.jsx
     */
    fromGallery: FromGalleryReducer,
    /**
     * To know delivery details related to store
     * src/components/VisitStoreToPurchase/VisitStoreToPurchase.jsx
     */
    visitStoreToPurchase: VisitStoreToPurchaseReducer,
    /**
     * To get urgency messages to display in delivery section
     * src/components/UrgencyMessaging/UrgencyMessaging.jsx
     * src/containers/Pages/PDP/PDP.jsx
     */
    urgencyStatements: UrgencyMessagingReducer,
    /**
     * To get collection of related items details
     * src/components/AddToCart/AddToCart.jsx
     * src/components/ProductCollection/ProductCollection.jsx
     */
    productCollection: ProductCollectionPricingReducer,
    /**
     * To get the invetory details
     * src/components/Bundle/BundleProductOptions/BundleProductOptions.jsx
     * src/containers/Pages/PDP/PDP.jsx
     * yoda-site-components/src/selectors/PdpNameSpaceSelector.js
     */
    inventory: PdpNameSpaceReducerCreator(InventoryReducer, false, 'inventory'),
    /**
     * To get product complete details like images, title webid etc
     * src/components/AddToCart/AddToCart.jsx
     * src/components/AddToList/AddToList.jsx
     * src/components/Bundle/BundleAddToCart/BundleAddToCart.jsx
     * src/components/Bundle/BundlePricing/BundlePricingWrapper.jsx
     * src/components/DeliveryOption/DeliveryOption.jsx
     * src/components/GeneralInformation/GeneralInformation.jsx
     * src/components/ShippingAndReturns/ShippingAndReturns.jsx
     * src/components/VisitStoreToPurchase/VisitStoreToPurchase.jsx
     * src/containers/Pages/PDP/Bundle/Bundle.jsx
     * src/containers/Pages/PDP/Common/Common.jsx
     * src/containers/Pages/PDP/PDP.jsx
     * src/selectors/Bundle/BundleCommonSelector.js
     * src/selectors/Bundle/BundleProductInfoSelector.js
     * src/selectors/Bundle/BundleProductOptionsSelector.js
     * yoda-microsite-pdp/src/selectors/Bundle/BundleProductPricingSelector.js
     * src/selectors/delivery/deliverOptionsSelector.js
     * src/selectors/PDPBreadCrumbsSelector.js
     * src/selectors/ProductCompareSelector.js
     * src/selectors/ProductInfo/ProductInfoSelector.js
     */
    productDetails: PdpNameSpaceReducerCreator(ProductDetailsReducer, false, 'productDetails'),
    /**
     * To get product options related details
     * src/components/AddToCart/AddToCart.jsx
     * src/components/Bundle/BundlePricing/BundlePricingWrapper.jsx
     * src/components/Bundle/BundleProductOptions/BundleProductOptions.jsx
     * src/components/ProductImage/ProductImage.jsx
     * src/selectors/Bundle/BundleProductOptionsSelector.js
     * src/selectors/Bundle/BundleProductPricingSelector.js
     */
    productOptions: PdpNameSpaceReducerCreator(ProductOptionsReducer, false, 'productOptions'),
    /**
     * To get product sku offering details
     * src/components/DeliveryOption/DeliveryOption.jsx
     * src/selectors/AddToCartSelector.js
     * src/selectors/delivery/deliverOptionsSelector.js
     * src/selectors/HolidayMessagingSelector.js
     * src/selectors/selectUpsell.js
     * yoda-site-components/src/selectors/fromState/index.js
     */
    productOffering: PdpNameSpaceReducerCreator(ProductPricingReducer, false, 'productOffering'),
    /**
     * To store user selected quantitlty
     * src/components/AddToCart/AddToCart.jsx
     * src/components/AddToCart/withAddToCartHOC.jsx
     * src/components/AddToList/AddToList.jsx
     * src/components/DeliveryOption/DeliveryOption.jsx
     * src/selectors/delivery/deliverOptionsSelector.js
     */
    selectedQuantity: PdpNameSpaceReducerCreator(QuantityReducer, false, 'selectedQuantity'),
    /**
     * To store couponDetails
     * yoda-site-components/src/components/FinalPriceAfterCoupon/FinalPriceAfterCoupon.jsx
     */
    couponDetails: CouponDetailsReducer,
    /**
     * To display delivery options details
     * src/components/AddToCart/AddToCart.jsx
     * src/selectors/delivery/deliverOptionsSelector.js
     */
    deliveryOptionsName: DeliveryOptionsNameReducer,
    /**
     * To display delivery ptions details
     * src/components/Bundle/BundlePricing/DeprecatedComponents/FPAC.jsx
     * yoda-site-components/src/components/FinalPriceAfterCoupon/FinalPriceAfterCoupon.jsx
     * yoda-site-components/src/components/SpecialOffers/SpecialOffers.jsx
     */
    signInSliderFrom: SignInSliderReducer,
    /**
     * To display Q&A and review section from bazaar voice
     * src/components/BazaarVoice/BazaarVoice.jsx
     */
    bazaarvoice: BazaarVoiceReducer,
    /**
     * To get minipdp/pdp alert status
     * yoda-microsite-listing/src/containers/Pages/Lists/ListLandingPageConnect.jsx
     */
    myAlerts: PdpNameSpaceReducerCreator(MyAlertsReducer, false, 'myAlerts'),
    /**
     * To rendor mini PDP on the PDP page
     * yoda-microsite-gallery/src/containers/Pages/Iris/IrisWrapper.jsx
     * yoda-microsite-listing/src/containers/Pages/Lists/ListLandingPageConnect.jsx
     * yoda-microsite-listing/src/containers/Pages/TrendingList/TrendingListConnect.jsx
     * src/components/AddToList/AddToList.jsx
     * yoda-mini-pdp/src/components/MiniPDPAddToCart/MiniPDPAddToCart.jsx
     * yoda-mini-pdp/src/components/MiniPDPInterstitial/MiniPDPInterstitial.jsx
     * yoda-mini-pdp/src/components/MiniPDPLayout/MiniPDPLayout.jsx
     * yoda-mini-pdp/src/selectors/selectMiniPDP.jsx
     * yoda-site-components/src/components/EcoRebates/EcoRebates.jsx
     * yoda-site-components/src/selectors/ProductOptionsSelector.js
     */
    miniPDP: MiniPDPReducer,

    /**
     * To get shop the look feature details
     * src/components/ShopTheLook/ShopTheLook.jsx
     */
    shopTheLook: ShopTheLookReducer,
    /**
     * To get bopis message info
     * yoda-site-components/src/selectors/BOPISMessageSelector.js
     */
    bopisMessageData: BOPISMessageReducer,
    /**
     * To get location based store information
     * yoda-site-components/src/selectors/BOPISMessageSelector.js
     */
    locationServiceReducer: LocationServiceReducer,
    /**
     * full screen loading
     * yoda-microsite-coupon/src/containers/Pages/Coupon/Coupon.jsx
     * yoda-microsite-coupon/src/helper/MiniPDPHelper.jsx
     * yoda-microsite-homepage/src/helper/MiniPDPHelper.jsx
     * yoda-microsite-marketing/src/helper/renderMiniPDP.jsx
     * yoda-microsite-pdp/src/components/AddToCart/AddToCart.jsx
     * yoda-microsite-pdp/src/components/Bundle/BundleAddToCart/BundleAddToCart.jsx
     * yoda-microsite-pdp/src/components/GeneralInformation/GeneralInformation.jsx
     * yoda-microsite-pdp/src/components/ImageZoom/ImageZoom.jsx
     * yoda-microsite-listing/src/common/CustomAddToCart/CustomAddToCart.jsx
     */
    isLoading: LoadingReducer,
    /**
     * MTLSavedLists
     * yoda-microsite-listing/src/components/Lists/Move/Move.jsx
     * yoda-microsite-pdp/src/components/AddToList/AddToList.jsx
     */
    MTLSavedLists,
    /**
     * messages on various pages
     * yoda-microsite-pdp/src/components/AddToCart/AddToCart.jsx
     * yoda-microsite-pdp/src/components/Bundle/BundleAddToCart/BundleAddToCart.jsx
     * yoda-microsite-pdp/src/components/Bundle/BundleChildLevel/BundleChildDetails.jsx
     * yoda-microsite-pdp/src/components/DeliveryDate/DeliveryDate.jsx
     * yoda-microsite-pdp/src/components/DeliveryOption/DeliveryOption.jsx
     * yoda-microsite-pdp/src/containers/Pages/PDP/Common/Common.jsx
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/NewCheckoutPage/NewCheckoutPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/Review/ReviewPage.jsx
     * yoda-site-components/src/components/YodaFooter/YodaFooter.jsx
     * Coupon page IRIS component "couponlist"
     * yoda-microsite-coupon/src/helper/MiniPDPHelper.jsx
     * yoda-microsite-pdp/src/containers/Pages/PDP/PDP.jsx
     * yoda-microsite-marketing/src/helper/renderMiniPDP.jsx
     * yoda-microsite-gallery/src/containers/Pages/Gallery/GalleryDesktop.jsx
     * yoda-microsite-pdp/src/containers/Pages/PDP/Regular/Regular.jsx
     */
    messages: PdpNameSpaceReducerCreator(MessagesReducer, false, 'messages'),

    /**
     * inline image loader
     * yoda-microsite-pdp/src/components/SlickCarouselLarge/SlickCarouselLarge.jsx
     * yoda-microsite-pdp/src/containers/Pages/PDP/Common/Common.jsx
     * mini-pdp
     */
    isInlineImageLoading: InlineImageLoaderReducer,
    /**
     * color swatches
     * yoda-microsite-pdp/src/selectors/Bundle/BundleImageSelector.js
     * yoda-microsite-pdp/src/components/ProductImage/ProductImage.jsx
     * yoda-microsite-pdp/src/components/SlickCarouselLarge/SlickCarouselLarge.jsx
     * yoda-microsite-pdp/src/components/StickyHeader/StickyHeader.jsx
     * yoda-microsite-pdp/src/containers/Pages/PDP/Common/Common.jsx
     */
    colorSwatches: PdpNameSpaceReducerCreator(ColorSwatchesReducer, false, 'colorSwatches'),
    /**
     * protection plan
     * yoda-microsite-pdp/src/components/AddToCart/AddToCart.jsx
     * yoda-microsite-pdp/src/components/AddToCart/withAddToCartHOC.jsx
     * yoda-microsite-pdp/src/components/DeliveryOption/DeliveryOption.jsx
     * yoda-microsite-pdp/src/components/StickyHeader/StickyHeader.jsx
     * yoda-microsite-pdp/src/containers/Pages/PDP/Regular/Regular.jsx
     */
    selectedProtectionPlan: PdpNameSpaceReducerCreator(
        ProtectionPlanReducer,
        false,
        'selectedProtectionPlan'
    ),
    /**
     * sdpu
     * yoda-microsite-pdp/src/components/AddToCart/AddToCart.jsx
     * yoda-microsite-pdp/src/components/DeliveryOption/DeliveryOption.jsx
     * yoda-microsite-pdp/src/components/VisitStoreToPurchase/VisitStoreToPurchase.jsx
     */
    sdpuStoreInfo: SdpuStoreInfoReducer,
    /**
     * BVReviews
     * yoda-microsite-pdp/src/components/ProductCompare/ProductCompare.jsx
     * yoda-microsite-pdp/src/containers/Pages/PDP/Common/Common.jsx
     */
    BVReviews: BVReviewsReducer,
    /**
     * my alerts
     * yoda-microsite-pdp/src/components/AddToCart/AddToCart.jsx
     * yoda-microsite-pdp/src/containers/Pages/PDP/Common/Common.jsx
     */
    myAlertsModalSlot: PdpNameSpaceReducerCreator(MyAlertsModalReducer, false, 'myAlertsModalSlot'),
    /**
     * To trigger DA events for protection plan and haul away service
     * yoda-checkout-components/lib/reducers/AnalyticsReducer.js
     */
    analyticsPageLevelData: DigitalAnalyticsDataReducer,
    /**
     * To set the product options preselected on page load when all the SKUs are selected
     * src/components/Bundle/BundleProductOptions/BundleProductOptions.jsx
     */
    bundleProductOptionsSelectedOnLoad: BundleProductOptionsOnLoadReducer,
    virtualTryOn: VirtualTryOnReducer,
    creditCardBannerData: CreditCardBannerReducer,
    cmCreditCardBannerData: CMCreditCardBannerReducer,
    webvitals: WebvitalsReducer,
    irisData: IrisReducer,
    bundleItemOffering: bundleItemOfferingReducer,
    /**
     * This to get quickscreebanner from /yoda-account-components/lib/components/SYFQuickScreen/QuickScreenLazy.js
     */
    syfQuickScreen: SYFQuickScreenReducer,
    shippingProtectionModal: ShippingProtectionModalReducer,
};

export default rootReducer;
